var env = require("../../utils/env");
var api = env.domain.api;
var request = require('superagent');
import CKEditor from "react-ckeditor-component";
import React from 'react';
import { requestPermission, uploadFileS3 } from '../../resources/media'

const uploadRequestListener = function(evt) {
    evt.stop();
    var file = evt.data.fileLoader.file;
    var xhr = evt.data.fileLoader.xhr;
    requestPermission({
      type: file.type,
      name: file.name
    }, function(err, result) {
      if (err) {
        evt.data.message = 'Error, please try again later';
        evt.cancel();
        return;
      };
      var xhr = evt.data.fileLoader.xhr;
      evt.data.fileLoader.requestData = {
        result: result
      };
      xhr.open( 'PUT', result.signed_request, true);
      xhr.send(file);
    })
}

const uploadResponseListener = function(evt) {
    evt.stop();
    var data = evt.data;
    var xhr = data.fileLoader.xhr;
    var requestData = data.fileLoader.requestData || {};
    if (xhr.status !== 200) {
        data.message = 'Error, please try again later';
        evt.cancel();
        return;
    }
    data.url = requestData.result.url;
    setTimeout(function() {
      evt.editor.fire('change');
    }, 500);
}

var CustomEditor = React.createClass({
  getInitialState: function() {
    var events = this.props.events || {};
    events.fileUploadRequest = uploadRequestListener;
    events.fileUploadResponse = uploadResponseListener;
    return {
      content: this.props.content,
      events: events
    }
  },
  componentWillReceiveProps: function(nextProps) {
    var events = nextProps.events || {};
    events.fileUploadRequest = uploadRequestListener;
    events.fileUploadResponse = uploadResponseListener;
    this.setState({
      content: nextProps.content || this.props.content,
      events: events
    })
  },

  render: function() {
    return (
      <CKEditor
        activeClass="p10"
        content={this.state.content || ''}
        isScriptLoaded= {true}
        events={this.state.events}
       />
    );
  }
});

export default CustomEditor;


/** WEBPACK FOOTER **
 ** ./src/components/CustomEditor/CustomEditor.js
 **/